<div class="modal-header">
    <h4 class="modal-title">Spremeni podatke osebe: {{ employee.name }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  <div class="modal-body">
    <form>
      <div class="mb-3">
        <label for="name" class="form-label">Ime</label>
        <input type="text" id="name" class="form-control" [(ngModel)]="employee.name" name="name">

      </div>
      <div class="mb-3">
        <label for="surname" class="form-label">Priimek</label>
        <input type="text" class="form-control" id="surname"  [(ngModel)]="employee.surname" name="surname">
      </div>
      <div class="mb-3">
        <label for="description" class="form-label">Opis</label>
        <textarea class="form-control" id="description" name="employeeDescription" [(ngModel)]="employee.employeeDescription" name="employeeDescription"></textarea>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Prekliči</button>
    <button type="button" class="btn btn-primary" (click)="save()">Shrani</button>
  </div>
  